import { useMutation, useQuery } from "@tanstack/react-query";
import { pharmacyLedgerService } from "modules/Pharmacy/DailyReconsilation/api/pharmacyledger";
// import { dailyAccountabilityService } from "api/pharmacy";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const usePharmacyLedgerService = ({
  searchText,
  pageNumber,
  pageSize,

  studyid,
  fromdate,
  todate,
  ipcategory,
  enableSelectall = false,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;

  studyid?: string | number | null;
  fromdate?: string | null;
  todate?: string | null;
  ipcategory?: string | null;
  enableSelectall?: boolean;
} = {}) => {

  /* =========================
     SELECT ALL (useQuery)
  ========================= */
  const SelectAllQuery = useQuery<ApiResponse>({
    queryKey: [
      "pharmacy-ledger-selectAll",
      { searchText, pageNumber, pageSize, ipcategory },
    ],
    queryFn: () =>
      pharmacyLedgerService.selectAll({
        searchtext: searchText ?? null,
        currentpage: pageNumber,
        pagesize: pageSize,
     
      }),
    enabled: false,
  });
  const SelectAllDailyAccountabilityQuery = useQuery<ApiResponse>({
    queryKey: [
      "daily-accountability-selectAll",
      { searchText, pageNumber, pageSize, studyid, fromdate, todate, ipcategory },
    ],
    queryFn: () =>
      pharmacyLedgerService.selectAllDailyAccountability({
        searchtext: searchText ?? null,
        currentpage: pageNumber,
        pagesize: pageSize,
        studyid,
        fromdate,
        todate,
        ipcategory: ipcategory && ipcategory !== "All" ? ipcategory : null,
      }),
      enabled: enableSelectall,
  });

  const ActualCountMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: pharmacyLedgerService.actualCount,
  });

  const UpdateActualCountMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: pharmacyLedgerService.updateActualCount,
  });

  const verifyPinMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: pharmacyLedgerService.verifyPin,
  });

  return {
    SelectAllQuery,
    SelectAllDailyAccountabilityQuery,
    ActualCountMutation,
    UpdateActualCountMutation,
    verifyPinMutation
  };
};